
import Loader from '~/components/widgets/Loader/Loader';

export default {
  name: 'CatalogList',

  data() {
    return {
      menu: [],
      isLoaded: false,

      currentCategory: {},
    };
  },
  components: { Loader },
  props: {
    catalog: {
      type: Array,
      default() {
        return [];
      },
    },
    isPageComponent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clickButton'],

  computed: {},

  methods: {
    clickButton() {
      this.$emit('clickButton');
    },
    setCurrentCategory(category) {
      if (category === this.currentCategory) {
        return;
      }
      this.currentCategory = category;
    },
  },
  mounted() {
    this.currentCategory = this.catalog?.[0] || {};
  },

};
